<template>
  <div class="mx-10 ma-5">
    <v-card
      class="pa-5"
      :style="{ border: '1px solid var(--primary-boarder-color)' }"
    >
      <div>
        <PageTitleWithSearch
          :title="'Invoices'"
          :btnName="'Add New Invoice'"
          :btnColor="'#00B3FF'"
          :btnRoute="'/invoice/create'"
          :btnPermission="'invoice.create'"
          :btnEnable="true"
          :loading="loading"
          :search="search"
          @searchText="searchChange($event)"
        >
        </PageTitleWithSearch>
        <v-data-table
          v-if="invoices && hasPermission('invoice.list')"
          :headers="headers"
          :items="invoices"
          :items-per-page="5"
          :hide-default-footer="true"
          :disable-sort="true"
          :disable-pagination="true"
          id="data-table"
        >
          <template v-slot:item="{ item, index }">
            <tr
              :class="[
                { 'first-row': index === 0 },
                index % 2 === 0 ? 'dark-row' : 'light-row',
                'custom-row',
              ]"
            >
              <td
                v-if="hasPermission('invoice.view')"
                class="text-left"
                @click="openPdfInvoice(item.invoice_id, item.invoice_no)"
                style="cursor: pointer;"
              >
                {{ item.invoice_no }}
              </td>
              <td v-else class="text-left">{{ item.invoice_no }}</td>
              <td>
                <router-link
                  :to="'/project/info/' + item.project.uuid"
                  class="router-link font-weight-medium"
                  >{{ item.reference }}</router-link
                >
              </td>
              <td>
                <router-link
                  :to="'/customer/' + item.customer.uuid + '/info'"
                  class="router-link font-weight-medium"
                  >{{ item.customer.full_name }}</router-link
                >
              </td>
              <td class="text-left">{{ item.due_date }}</td>
              <td class="text-center" v-if="item.status">
                <v-chip
                  small
                  class="ma-2"
                  dark
                  :color="getStatusColor(item.status)"
                >
                  {{ stringFormatting(item.status) }}
                </v-chip>
              </td>
              <td class="text-center">
                <v-btn
                  class="mx-2"
                  color="#FFE0B2"
                  :to="'/invoice/edit/' + item.uuid"
                  fab
                  small
                  style="box-shadow: none;"
                  v-if="hasPermission('invoice.edit')"
                >
                  <v-icon small color="#FF9800"> mdi-pencil </v-icon>
                </v-btn>
                <v-btn
                  class="mx-2"
                  small
                  color="#C5E1A5"
                  @click="getPdfInvoice(item.invoice_id, item.invoice_no)"
                  fab
                  style="box-shadow: none;"
                  v-if="hasPermission('invoice.download')"
                >
                  <v-icon small color="#689F38"> mdi-download </v-icon>
                </v-btn>
                <v-btn
                  class="mx-2"
                  small
                  color="#FFCDD2"
                  @click="dropMemberConfirm(item.uuid)"
                  fab
                  style="box-shadow: none;"
                  v-if="hasPermission('invoice.delete')"
                >
                  <v-icon small color="#F44336">
                    mdi-delete
                  </v-icon>
                </v-btn>
              </td>
            </tr>
          </template>
        </v-data-table>
      </div>
      <v-row class="my-1">
        <Pagination
          v-model="page"
          :loading="loading"
          :total="total"
          :page="page"
        ></Pagination>
      </v-row>
    </v-card>
    <ConfirmModal
      :text="'Do you want to drop this invoice?'"
      :title="'Drop Invoice'"
      :color="'red'"
      :confirmOpen="confirmOpen"
      @cancelConfirm="cancelConfirm()"
      @confirm="confirm()"
    ></ConfirmModal>
    <Snackbars
      :text="successMsg"
      :snackbar="snackbar"
      :color="'warning'"
      @classSnackbar="closeSnackbar"
    />
  </div>
</template>

<style scoped></style>
<script>
import { createNamespacedHelpers } from "vuex";
const { mapGetters } = createNamespacedHelpers("auth");

import PageTitleWithSearch from "@/components/shared/PageTitleWithSearch";
import Pagination from "@/components/shared/Pagination";
import Snackbars from "@/components/shared/Snackbars";
import { InvoiceService } from "@/services/invoice-service.js";
import { checkError } from "@/config/errors.js";
import ConfirmModal from "@/components/shared/ConfirmModal";

export default {
  name: "InvoiceGrid",
  components: { PageTitleWithSearch, Pagination, Snackbars, ConfirmModal },
  data: function() {
    return {
      invoices: [],
      page: 1,
      search: "",
      loading: false,
      role: localStorage.getItem("role") || null,
      total: 0,
      totalInvoice: 0,
      dropId: null,
      confirmOpen: false,
      snackbar: false,
      successMsg: "Pdf not available",
      defaultImage: require("@/assets/img/avatar.svg"),
      skill: 20,
      pdfContent: null,
      headers: [
        { text: "Invoice No", value: "suburb", align: "left" },
        { text: "Reference", value: "code", align: "left" },
        { text: "Customer", value: "code", align: "left" },
        { text: "Due Date", value: "mobile", align: "left" },
        { text: "Status", value: "email", align: "center" },
        { text: "Actions", value: "actions", align: "center" },
      ],
    };
  },
  computed: {
    ...mapGetters({
      profile: "profile",
      hasPermission: "hasPermission",
    }),
  },
  mounted() {
    this.$store.dispatch("auth/getProfile");
    this.getInvoiceList();
  },

  watch: {
    search() {
      this.page = 1;
      this.getInvoiceList();
    },
    page() {
      this.getInvoiceList();
    },
  },

  methods: {
    getInvoiceList() {
      this.loading = true;
      InvoiceService.getInvoiceList(this.search, this.page)
        .then((response) => {
          this.loading = false;
          if (response.data.data) {
            this.invoices = response.data.data;
            this.total = response.data.meta.last_page || 0;
            this.totalInvoice = response.data.meta.total || 0;
          }
        })
        .catch((error) => {
          this.loading = false;
          this.invoices = [];
          let data = error.response.data;
          let errorOutput = checkError.errorFormatting(data);
          this.errors = errorOutput;
        });
    },
    stringFormatting(str) {
      return str.replace(/_/g, " ");
    },

    getPdfInvoice(invoice_id, invoice_no) {
      if (invoice_id === null) {
        this.snackbar = true;
      } else {
        this.loading = true;
        InvoiceService.getPdfInvoice(invoice_id)
          .then((response) => {
            this.loading = false;
            if (response.data) {
              this.pdfContent = response.data;
              this.downloadPDF(this.pdfContent, invoice_no);
            }
          })
          .catch((error) => {
            this.loading = false;
            this.pdfContent = "";
            let data = error.response.data;
            let errorOutput = checkError.errorFormatting(data);
            this.errors = errorOutput;
          });
      }
    },

    openPdfInvoice(invoice_id, invoice_no) {
      if (invoice_id === null) {
        this.snackbar = true;
      } else {
        this.loading = true;
        InvoiceService.getPdfInvoice(invoice_id)
          .then((response) => {
            this.loading = false;
            if (response.data) {
              this.pdfContent = response.data;
              this.openPDF(this.pdfContent, invoice_no);
            }
          })
          .catch((error) => {
            this.loading = false;
            this.pdfContent = "";
            let data = error.response.data;
            let errorOutput = checkError.errorFormatting(data);
            this.errors = errorOutput;
          });
      }
    },

    downloadPDF(pdfCon, invoice_no) {
      const blob = new Blob([pdfCon], { type: "application/pdf" });
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = `${invoice_no}.pdf`; // Set the desired file name
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },

    openPDF(pdfCon, invoice_no) {
      const blob = new Blob([pdfCon], { type: "application/pdf" });
      const url = window.URL.createObjectURL(blob);
      const newWindow = window.open(url, "_blank");
      newWindow.document.title = `${invoice_no}.pdf`;
    },

    getStatusColor(status) {
      let bgColor = "";
      switch (true) {
        case status === "PAID":
          bgColor = "#A5D6A7";
          break;
        case status === "UNPAID":
          bgColor = "#EF9A9A";
          break;
        case status === "DRAFT":
          bgColor = "blue";
          break;
      }
      return bgColor;
    },

    searchChange(value) {
      this.search = value;
    },

    dropMemberConfirm(uuid) {
      this.dropId = uuid;
      this.confirmOpen = true;
    },

    cancelConfirm() {
      this.confirmOpen = false;
    },

    confirm() {
      this.confirmOpen = false;
      this.dropMember();
    },

    dropMember() {
      if (this.dropId) {
        this.loading = true;
        InvoiceService.dropMember(this.dropId)
          .then((response) => {
            if (response.data == "Success") {
              this.loading = false;
              this.getInvoiceList();
            } else {
              this.loading = false;
              this.snackbar = true;
            }
          })
          .catch((error) => {
            this.loading = false;
            this.snackbar = false;
            let data = error.response.data;
            let errorOutput = checkError.errorFormatting(data);
            this.errors = errorOutput;
          });
      }
    },

    closeSnackbar() {
      this.snackbar = false;
    },
  },
};
</script>
